module.exports = __webpack_public_path__ + "static/img/search_bg.70d5abf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/new_home/search_bg.jpg
// module id = 517
// module chunks = 0